import { render, staticRenderFns } from "./CardBindingRecord.vue?vue&type=template&id=366cfdbb&scoped=true&"
import script from "./CardBindingRecord.vue?vue&type=script&lang=js&"
export * from "./CardBindingRecord.vue?vue&type=script&lang=js&"
import style0 from "./CardBindingRecord.vue?vue&type=style&index=0&id=366cfdbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366cfdbb",
  null
  
)

export default component.exports